import script from "./BranchCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./BranchCard.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__